import { render, staticRenderFns } from "./Sertifikasi.vue?vue&type=template&id=7d5e623c&"
import script from "./Sertifikasi.vue?vue&type=script&lang=js&"
export * from "./Sertifikasi.vue?vue&type=script&lang=js&"
import style0 from "./Sertifikasi.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports